var COMPARISON_ACROSS_OUTCOMES, ID_CONNECTOR, NETWORK_ESTIMATE_TYPE, OUTCOME_ACROSS_COMPARISONS, VALID_THRESHOLD_TYPES, buildAbsoluteEffectChartRow, buildComparisonThresholdChartData, buildNmaData, buildOutcomeThresholdChartData, buildRegularNmaData, buildThresholdPlotData, gdtDataToNmaData, getDefaultVizConfig, getNmaQuestionOutcomes, getQuestionTitle, getRowId, getThresholdTypeFromRegularQuestion, nmaDataToVizData, regularGdtQuestionToNmaInterventionsAndOutcomes, resolveThresholdSummaries, resolveThresholds, resolveValueDomain, sortNullableNumbers, _ref,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

_ref = require('lib/nma_helper'), gdtDataToNmaData = _ref.gdtDataToNmaData, nmaDataToVizData = _ref.nmaDataToVizData, regularGdtQuestionToNmaInterventionsAndOutcomes = _ref.regularGdtQuestionToNmaInterventionsAndOutcomes;

VALID_THRESHOLD_TYPES = ['MinimallyImportantDifferences', 'MagnitudeOfEffect'];

COMPARISON_ACROSS_OUTCOMES = 'comparisonAcrossOutcomes';

OUTCOME_ACROSS_COMPARISONS = 'outcomeAcrossComparisons';

ID_CONNECTOR = '#';

NETWORK_ESTIMATE_TYPE = 'Network';

sortNullableNumbers = function(a, b) {
  if (a === null && b === null) {
    return 0;
  }
  if (a === null) {
    return -1;
  }
  if (b === null) {
    return 1;
  }
  return a - b;
};

getRowId = function(rowData) {
  var _ref1, _ref2;
  return _.compact([(_ref1 = rowData.rowElement) != null ? _ref1.id : void 0, (_ref2 = rowData.comparator) != null ? _ref2.id : void 0]).join(ID_CONNECTOR);
};

getQuestionTitle = function(question) {
  var _ref1, _ref2;
  if (question == null) {
    return '';
  }
  return (_ref1 = (_ref2 = typeof question.get === "function" ? question.get('question') : void 0) != null ? _ref2 : question.question) != null ? _ref1 : '';
};

getThresholdTypeFromRegularQuestion = function(question) {
  var outcomes, thresholdType, _ref1;
  outcomes = (_ref1 = typeof question.get === "function" ? question.get('outcomes', Immutable.List()) : void 0) != null ? _ref1 : Immutable.List();
  thresholdType = outcomes.map(function(outcome) {
    return outcome.get('thresholdsType');
  }).find(function(value) {
    return __indexOf.call(VALID_THRESHOLD_TYPES, value) >= 0;
  });
  return thresholdType;
};

getNmaQuestionOutcomes = function(question, outcomesById) {
  if (question == null) {
    return Immutable.List();
  }
  return question.get('outcomes', Immutable.List()).map(function(outcomeId) {
    return outcomesById.get(outcomeId);
  }).filter(function(outcome) {
    return outcome != null;
  }).toList();
};

buildRegularNmaData = function(question) {
  var converted, nmaQuestion, thresholdType, _ref1, _ref2, _ref3;
  if (question == null) {
    return;
  }
  thresholdType = getThresholdTypeFromRegularQuestion(question);
  if (!thresholdType) {
    return;
  }
  converted = regularGdtQuestionToNmaInterventionsAndOutcomes(question.toJS(), question.get('_id'));
  if (!((converted != null ? (_ref1 = converted.interventions) != null ? _ref1.length : void 0 : void 0) && (converted != null ? (_ref2 = converted.outcomes) != null ? _ref2.length : void 0 : void 0))) {
    return;
  }
  nmaQuestion = Immutable.fromJS({
    _id: question.get('_id'),
    question: getQuestionTitle(question),
    interventions: converted.interventions,
    outcomes: _.pluck(converted.outcomes, '_id'),
    thresholdOptions: thresholdType,
    commonComparator: (_ref3 = converted.interventions[1]) != null ? _ref3._id : void 0
  });
  return gdtDataToNmaData(nmaQuestion, Immutable.fromJS(converted.outcomes));
};

buildNmaData = function(question, outcomesById) {
  var outcomes;
  outcomes = getNmaQuestionOutcomes(question, outcomesById);
  if ((question != null ? typeof question.isEmpty === "function" ? question.isEmpty() : void 0 : void 0) || outcomes.isEmpty()) {
    return;
  }
  return gdtDataToNmaData(question, outcomes);
};

getDefaultVizConfig = function(question, nmaData, config) {
  var comparatorId, firstInterventionId, interventions, outcomes, questionVizConfig, selectedInterventionIds, selectedOutcomeIds, _base, _ref1, _ref10, _ref11, _ref12, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;
  if (config == null) {
    config = {};
  }
  questionVizConfig = (question != null ? question.get : void 0) != null ? (_ref1 = typeof (_base = question.get('vizConfig', Immutable.Map())).toJS === "function" ? _base.toJS() : void 0) != null ? _ref1 : {} : {};
  config = _.extend({}, questionVizConfig, config);
  interventions = (_ref2 = nmaData.interventions) != null ? _ref2 : [];
  outcomes = (_ref3 = nmaData.outcomes) != null ? _ref3 : [];
  firstInterventionId = (_ref4 = interventions[0]) != null ? _ref4.id : void 0;
  comparatorId = (_ref5 = (_ref6 = config.comparatorId) != null ? _ref6 : question != null ? typeof question.get === "function" ? question.get('commonComparator') : void 0 : void 0) != null ? _ref5 : firstInterventionId;
  selectedInterventionIds = (_ref7 = config.selectedInterventionIds) != null ? _ref7 : _.chain(interventions).pluck('id').without(comparatorId).value();
  selectedOutcomeIds = (_ref8 = config.selectedOutcomeIds) != null ? _ref8 : _.pluck(outcomes, 'id');
  return _.extend({}, config, {
    comparatorId: comparatorId,
    comparatorTableMode: (_ref9 = config.comparatorTableMode) != null ? _ref9 : 'CommonComparator',
    denominator: (_ref10 = config.denominator) != null ? _ref10 : NmaComponents.STANDARD_DENOMINATOR,
    interventionComparisonPairs: (_ref11 = config.interventionComparisonPairs) != null ? _ref11 : [],
    selectedInterventionIds: selectedInterventionIds,
    selectedOutcomeIds: selectedOutcomeIds,
    tableOrder: (_ref12 = config.tableOrder) != null ? _ref12 : {},
    thresholdType: nmaData.thresholdType
  });
};

buildThresholdPlotData = function(_arg) {
  var config, data, nmaData, nmaOutcomes, nmaQuestions, outcomes, qId, question, regularQuestions, selectedInterventions, selectedOutcomeIds, sourceType, vizConfig, _ref1;
  sourceType = _arg.sourceType, qId = _arg.qId, regularQuestions = _arg.regularQuestions, nmaQuestions = _arg.nmaQuestions, nmaOutcomes = _arg.nmaOutcomes, vizConfig = _arg.vizConfig;
  if (sourceType === 'nma') {
    question = nmaQuestions.find(function(question) {
      return question.get('_id') === qId;
    });
    nmaData = buildNmaData(question, nmaOutcomes);
  } else {
    question = regularQuestions.get(qId);
    nmaData = buildRegularNmaData(question);
  }
  if (!((question != null) && (_ref1 = nmaData != null ? nmaData.thresholdType : void 0, __indexOf.call(VALID_THRESHOLD_TYPES, _ref1) >= 0))) {
    return;
  }
  config = getDefaultVizConfig(question, nmaData, vizConfig);
  selectedInterventions = nmaData.interventions.filter(function(intervention) {
    return config.selectedInterventionIds.includes(intervention.id);
  });
  data = nmaDataToVizData(nmaData.interventions, selectedInterventions, config.interventionComparisonPairs, nmaData.comparisons, config.comparatorId, config.comparatorTableMode);
  selectedOutcomeIds = config.selectedOutcomeIds;
  outcomes = nmaData.outcomes.filter(function(outcome) {
    return selectedOutcomeIds.includes(outcome.id);
  });
  return {
    question: question,
    nmaData: nmaData,
    config: config,
    data: data,
    outcomes: outcomes,
    thresholdType: nmaData.thresholdType
  };
};

resolveThresholds = function(outcome, thresholdMode) {
  if (thresholdMode === 'MinimallyImportantDifferences') {
    if (outcome.T1 == null) {
      return [];
    }
    return [
      {
        id: 't1',
        name: 'Threshold',
        value: outcome.T1
      }
    ];
  }
  return [
    outcome.T1 != null ? {
      id: 't1',
      name: 'Small',
      value: outcome.T1
    } : null, outcome.T2 != null ? {
      id: 't2',
      name: 'Moderate',
      value: outcome.T2
    } : null, outcome.T3 != null ? {
      id: 't3',
      name: 'Large',
      value: outcome.T3
    } : null
  ].filter(function(threshold) {
    return threshold != null;
  });
};

resolveThresholdSummaries = function(outcome, thresholdMode, denominator) {
  var thresholds;
  if (thresholdMode === 'MinimallyImportantDifferences') {
    if (outcome.T1 == null) {
      return;
    }
    return [
      {
        label: 'Threshold',
        value: outcome.T1,
        denominator: denominator
      }
    ];
  }
  thresholds = [
    outcome.T1 != null ? {
      label: 'Small',
      value: outcome.T1,
      denominator: denominator
    } : null, outcome.T2 != null ? {
      label: 'Moderate',
      value: outcome.T2,
      denominator: denominator
    } : null, outcome.T3 != null ? {
      label: 'Large',
      value: outcome.T3,
      denominator: denominator
    } : null
  ].filter(function(threshold) {
    return threshold != null;
  });
  if (thresholds.length) {
    return thresholds;
  } else {
    return void 0;
  }
};

resolveValueDomain = function(rows, thresholds) {
  var limit, maxAbs, maxValue, minValue, padding, values;
  values = _.flatten(rows.map(function(row) {
    var effect, _ref1;
    effect = row.absoluteEffect;
    if (!effect) {
      return thresholds.map(function(threshold) {
        return threshold.value;
      });
    }
    return [effect.estimate, effect.ciLow, effect.ciHigh].concat(thresholds.map(function(threshold) {
      return threshold.value;
    })).concat(((_ref1 = row.thresholds) != null ? _ref1 : []).map(function(threshold) {
      return threshold.value;
    })).concat([0]);
  }));
  minValue = values.length ? Math.min.apply(Math, values) : 0;
  maxValue = values.length ? Math.max.apply(Math, values) : 0;
  maxAbs = Math.max(Math.abs(minValue), Math.abs(maxValue), 1);
  padding = Math.max(maxAbs * 0.12, 2);
  limit = maxAbs + padding;
  return [-limit, limit];
};

buildAbsoluteEffectChartRow = function(_arg) {
  var absoluteEffect, ciHigh, ciLow, denominator, effectEstimate, label, outcome, outcomeData, rowId, thresholdMode, _ref1, _ref2, _ref3, _ref4, _ref5;
  denominator = _arg.denominator, label = _arg.label, outcome = _arg.outcome, outcomeData = _arg.outcomeData, rowId = _arg.rowId, thresholdMode = _arg.thresholdMode;
  effectEstimate = (_ref1 = outcomeData.estimates) != null ? _ref1[(_ref2 = outcomeData.estimateToUse) != null ? _ref2 : NETWORK_ESTIMATE_TYPE] : void 0;
  if (!(((effectEstimate != null ? effectEstimate.value : void 0) != null) && ((effectEstimate != null ? effectEstimate.ciLow : void 0) != null) && ((effectEstimate != null ? effectEstimate.ciHigh : void 0) != null))) {
    return;
  }
  absoluteEffect = NmaComponents.getAbsoluteEffect(effectEstimate, outcome.baselineRisk, outcome.type, denominator, (_ref3 = outcomeData.hasBeenFlipped) != null ? _ref3 : false);
  if (!((absoluteEffect.absoluteEffectValue != null) && (absoluteEffect.absoluteEffectCiLow != null) && (absoluteEffect.absoluteEffectCiHigh != null))) {
    return;
  }
  _ref4 = [absoluteEffect.absoluteEffectCiLow, absoluteEffect.absoluteEffectCiHigh].sort(sortNullableNumbers), ciLow = _ref4[0], ciHigh = _ref4[1];
  return {
    id: rowId,
    label: label,
    higherIsBetter: (_ref5 = outcome.higherIsBetter) != null ? _ref5 : false,
    absoluteEffect: {
      estimate: absoluteEffect.absoluteEffectValue,
      ciLow: ciLow,
      ciHigh: ciHigh,
      denominator: outcome.type === 'Continuous' ? void 0 : denominator,
      unit: outcome.units
    },
    thresholds: resolveThresholdSummaries(outcome, thresholdMode, denominator)
  };
};

buildOutcomeThresholdChartData = function(_arg) {
  var data, denominator, i18next, outcome, rows, thresholdMode, thresholds;
  data = _arg.data, denominator = _arg.denominator, i18next = _arg.i18next, outcome = _arg.outcome, thresholdMode = _arg.thresholdMode;
  if (__indexOf.call(VALID_THRESHOLD_TYPES, thresholdMode) < 0) {
    return;
  }
  thresholds = resolveThresholds(outcome, thresholdMode);
  if (!thresholds.length) {
    return;
  }
  rows = _.compact(data.map(function(interventionData) {
    var label, outcomeData, rowId, _ref1, _ref2, _ref3;
    outcomeData = (_ref1 = interventionData.outcomes) != null ? _ref1[outcome.id] : void 0;
    if (outcomeData == null) {
      return;
    }
    label = i18next.t('nma:common_comparator_table.intervention_vs_comparator', {
      intervention: (_ref2 = interventionData.rowElement) != null ? _ref2.name : void 0,
      comparator: (_ref3 = interventionData.comparator) != null ? _ref3.name : void 0
    });
    rowId = interventionData.comparator != null ? "" + interventionData.rowElement.id + "-" + interventionData.comparator.id : interventionData.rowElement.id;
    return buildAbsoluteEffectChartRow({
      denominator: denominator,
      label: label,
      outcome: outcome,
      outcomeData: outcomeData,
      rowId: rowId,
      thresholdMode: thresholdMode
    });
  }));
  if (!rows.length) {
    return;
  }
  return {
    rows: rows,
    thresholds: thresholds,
    valueDomain: resolveValueDomain(rows, thresholds)
  };
};

buildComparisonThresholdChartData = function(_arg) {
  var chartThresholds, comparison, denominator, outcomes, rows, thresholdMode;
  comparison = _arg.comparison, denominator = _arg.denominator, outcomes = _arg.outcomes, thresholdMode = _arg.thresholdMode;
  if (__indexOf.call(VALID_THRESHOLD_TYPES, thresholdMode) < 0) {
    return;
  }
  rows = [];
  chartThresholds = [];
  outcomes.forEach(function(outcome) {
    var outcomeData, row, thresholds, _ref1, _ref2;
    thresholds = resolveThresholds(outcome, thresholdMode);
    if (!thresholds.length) {
      return;
    }
    outcomeData = (_ref1 = comparison.outcomes) != null ? _ref1[outcome.id] : void 0;
    if (outcomeData == null) {
      return;
    }
    row = buildAbsoluteEffectChartRow({
      denominator: denominator,
      label: (_ref2 = outcome.name) != null ? _ref2 : '',
      outcome: outcome,
      outcomeData: outcomeData,
      rowId: outcome.id,
      thresholdMode: thresholdMode
    });
    if (row == null) {
      return;
    }
    rows.push(row);
    if (!chartThresholds.length) {
      return chartThresholds = thresholds;
    }
  });
  if (!(rows.length && chartThresholds.length)) {
    return;
  }
  return {
    rows: rows,
    thresholds: chartThresholds,
    valueDomain: resolveValueDomain(rows, chartThresholds)
  };
};

module.exports = {
  COMPARISON_ACROSS_OUTCOMES: COMPARISON_ACROSS_OUTCOMES,
  OUTCOME_ACROSS_COMPARISONS: OUTCOME_ACROSS_COMPARISONS,
  buildComparisonThresholdChartData: buildComparisonThresholdChartData,
  buildThresholdPlotData: buildThresholdPlotData,
  buildOutcomeThresholdChartData: buildOutcomeThresholdChartData,
  getRowId: getRowId
};
